import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id BE00F5DD-75FB-43C5-BE8F-56117E1EC823
 * name folder-settings-outline
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-settings-outline.svg
 * tags
 * - Settings 
 * - Files / Folders 
 */
export const FolderSettingsOutlineIcon = createSvgIcon(<><path d="M4 4C2.89 4 2 4.89 2 6V18A2 2 0 0 0 4 20H20A2 2 0 0 0 22 18V8C22 6.89 21.1 6 20 6H12L10 4H4M4 8H20V18H4V8M7 22V24H9V22H7M11 22V24H13V22H11M15 22V24H17V22H15" /></>, 'FolderSettingsOutlineIcon');
export default FolderSettingsOutlineIcon